const configuration = {
  // baseUrl: 'http://15.206.75.181:8088/api/v1.0'
  // baseUrl: 'https://dev.fabric.carynhealth.com/api/v2.0/'
  baseUrl: process.env.REACT_APP_BASE_URL_ENROLLMENT
}
export default configuration
